<div>
  <a class="btn btn-link">
    <mat-icon [matMenuTriggerFor]="popoverMenu">more_horizontal</mat-icon>
  </a>
</div>

<mat-menu
  #popoverMenu
  class="no-padding more-menu"
>
  <button
    mat-menu-item
    class="menu-button"
    [disabled]="candidate.warning"
    [ngClass]="{ 'disabled': candidate.warning }"
    (click)="setBadge(badges.FAVORITE)"
  >
    <mat-icon>favorite</mat-icon>
    <span class="button-text">Favorite</span>
  </button>
  <button
    mat-menu-item
    class="menu-button"
    [disabled]="candidate.warning"
    [ngClass]="{ 'disabled': candidate.warning }"
    (click)="setBadge(badges.SILVER)"
  >
    <mat-icon>star</mat-icon>
    <span class="button-text">Silver medalist</span>
  </button>
  <button
    *mojoHasFeatureExtension="alumniFeatureExtension"
    mat-menu-item
    class="menu-button"
    [disabled]="candidate.warning"
    [ngClass]="{ 'disabled': candidate.warning }"
    (click)="setBadge(badges.ALUMNI)"
  >
    <mat-icon>school</mat-icon>
    <span class="button-text">Alumni</span>
  </button>
  <button
    mat-menu-item
    class="menu-button"
    [disabled]="candidate.favorite || candidate.silver"
    [ngClass]="{ 'disabled': candidate.favorite || candidate.silver }"
    (click)="setBadge(badges.WARNING)"
  >
    <mat-icon>warning</mat-icon>
    <span class="button-text">Warning</span>
  </button>
  <button
    mat-menu-item
    class="menu-button"
    *ngIf="(candidate.status !== deletedCandidate) && isFullBadges"
    (click)="deleteCandidate()"
  >
    <mat-icon>
      delete
    </mat-icon>
    <span class="button-text">Delete</span>
  </button>
</mat-menu>
